// extracted by mini-css-extract-plugin
export default {"table":"permissions_table__jxRmd","cell":"permissions_cell__cwvd-","right":"permissions_right__+FE+3"};